<template>
    <div id="assets_layout">
        <div
            is="ErrorBox"
            :errors="errors"
        >
        </div>
        <div class="ui grid segment">
            <div class="four wide column">
                <div class="ui basic icon buttons">
                    <router-link :to="{name: 'new_asset'}"
                        :data-tooltip="$t('ui.page_titles.new_asset')"
                        class="ui button"
                        v-popup>
                        <i class="plus icon"></i>
                    </router-link>
                </div>
                <div class="ui divider"></div>
                <div v-if="is_initialized" class="ui secondary fluid vertical pointing text menu">
                    <div class="item">
                        <h4 class="ui grey header">
                            {{ $t('models.attributes.assets.category') }}
                        </h4>
                    </div>
                    <a
                        is="LayoutMenuItem"
                        v-for="category in categories"
                        :category="category"
                    ></a>
                    <div v-if="categories.length < 1" class="item">
                        {{ $t('ui.pages.assets.helps.no_anything_category') }}
                    </div>
                </div>
            </div>
            <div class="twelve wide column">
                <transition v-if="is_initialized" name="slide-fade" mode="out-in" appear>
                    <router-view></router-view>
                </transition>
                <div v-else>
                    <div class="ui inverted dimmer transition visible active" style="display: block !important;">
                        <div class="ui text loader">
                            {{ $t('ui.general.initializing') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LayoutMenuItem from './layout_menu_item.vue'
import ErrorBox from '../.components/errors.vue'
export default {
    name: "AssetsLayout",
    data() {
        return {
            is_initialized: false,
            errors: []
        }
    },
    computed: {
        categories() {
            return this.$store.state.provider.assets_module.categories
        },
    },
    created() {
    },
    mounted() {
        this.init()

        this.$bus.$off('init')
        this.$bus.$on('init', (value = false) => {
            this.init()
        })
    },
    beforeDestroy() {
        this.$bus.$off('init')
    },
    watch: {
    },
    methods: {
        async init() {
            await this.fetch_categories()
            await new Promise(resolve => {
                this.$noty.information(
                    this.$t("ui.page_titles.assets") + ' ' +
                    this.$t('ui.general.initialize_complete')
                )
                this.is_initialized = true
                resolve()
            })
        },
        fetch_categories() {
            var url = this.$store.state.provider.routes.api_v1_provider_assets
            return axios.get(
                    url,
                    {headers: { Authorization: localStorage.getItem("authentication_token") }}
                )
                .then(response => {
                    this.$store.state.provider.assets_module.categories = response.data.categories
                    return response
                })
                .catch(error => {
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('ui.pages.assets.categories'),
                            reason: ': ' + error
                        })
                    )
                    return Promise.reject(error)
                })
        },
    },
    components: {
        LayoutMenuItem,
        ErrorBox
    }
}
</script>
